import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';

import { bgGradient } from 'src/theme/css';

import Iconify from 'src/components/iconify';
import { varFade, MotionViewport } from 'src/components/animate';

// ----------------------------------------------------------------------

export default function HomeContentCTA() {
  const theme = useTheme();
  return (
    <Container sx={{ mb: 10, mt: 5 }} component={MotionViewport}>
      <Stack
        alignItems="center"
        justifyContent="center"
        direction={{ xs: 'column', md: 'row' }}
        sx={{
          ...bgGradient({
            direction: '135deg',
            startColor: theme.palette.primary.main,
            endColor: theme.palette.primary.dark,
          }),
          py: 8,
          borderRadius: 1,
          pb: { xs: 5, md: 5 },
        }}
      >
        <Description />
      </Stack>
    </Container>
  );
}

function Description() {
  return (
    <Box
      sx={{
        textAlign: {
          xs: 'center',
          md: 'center',
        },
      }}
    >
      <Box
        component={m.div}
        variants={varFade().inDown}
        sx={{ color: 'common.white', mb: 2, typography: { xs: 'h4', md: 'h2' } }}
      >
        Explore the Art of Web Elevation
      </Box>
      <Box
        component={m.div}
        variants={varFade().inDown}
        sx={{ color: 'common.white', mb: 5, typography: { xs: 'h6', md: 'h4' } }}
      >
        Join free for access to expert blogs, videos, and the latest tech news. Stay updated and
        elevate your web development skills with curated content!
      </Box>

      <m.div variants={varFade().inRight}>
        <Button
          size="large"
          variant="contained"
          href="/post"
          endIcon={<Iconify icon="eva:external-link-fill" width={24} />}
          sx={{
            background: 'linear-gradient(135deg, #FF6B6B, #FF3D71)',
            color: 'common.white',
            px: 5,
            py: 1.5,
            fontWeight: 700,
            textTransform: 'uppercase',
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: 'scale(1.05)',
              boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
            },
          }}
        >
          YouTube Channel
        </Button>
      </m.div>
    </Box>
  );
}
